import { get } from 'lodash';
import { useNotifications } from '@toolpad/core/useNotifications';
import { useNavigate } from 'react-router-dom';

import queriesConfig from '../Services/queriesConfig';
import { loginPath, spacePath } from '../Utils/routes';
import useApiQuery from './useApiQuery';
import { notify } from '../Utils/NotificationUtils';
import useCurrentUser from './useCurrentUser';

const usePostQuery = (postId: number | string, useQueryProps?: any) => {
  const navigate = useNavigate();
  const notifications = useNotifications();
  const { isLoggedIn } = useCurrentUser();

  const { data, ...params } = useApiQuery({
    query: queriesConfig.getPost(postId),
    options: {
      enabled: !!window.spaceSlug && Boolean(postId),
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      ...useQueryProps,
    },
    onSettled: (response) => {
      if (response && !response.ok) {
        if ([404, 500].includes(response?.status)) {
          navigate(`/${response.status}`);
        }

        if (response?.status === 403) {
          notify(notifications, get(response, 'data.errors[0].detail'), 'error');

          if (isLoggedIn) {
            navigate(spacePath());
          } else {
            navigate(loginPath());
          }
        }
      }
    },
  });

  return {
    post: data,
    ...params,
  };
};

export default usePostQuery;
